<!--
   浏览器异常

   @date:2022/09/07
   @author 金星晖<xinghui0928@163.com, www.xinghuijin.com>
   @copyright 南京云柜<yun-gui.com>
-->
<style lang="less">
#err-300 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  img.err-img {
    width: 300px;
  }
  .info {
    margin-top: 20px;
    font-size: 18px;
    color: @textColorLight;
  }
}
</style>

<template>
  <div id="err-300">
    <img
      src="/bg/light-bg-401.png"
      alt="浏览器异常"
      class="err-img"
    >
    <div class="info">
      浏览器异常，请使用谷歌浏览器
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data () {
    return {};
  },
  methods: {}
};
</script>
